import { appCourseTeaserSlider } from './app_course_teasers';

export const appProjectTeaser = {
    create: function () {
      var that = this;
      if ($('.js-project-teaser').length) {
        $('.js-project-teaser-slider').each(function (index) {
          var main = $(this).parents().eq(2),
            prevButton = $(main).find('.js-project-teaser-prev'),
            nextButton = $(main).find('.js-project-teaser-next');
          //console.log('<: ', prevButton);
          //console.log('>: ', nextButton);
          $(this).attr('data-ndx', index);
          $(prevButton).attr('data-ndx', index);
          $(nextButton).attr('data-ndx', index);
        });
        setTimeout(function () {
          that.initProjectTeaserSliders();
        }, 50);
        that.bindEvents();
      }
    },
    bindEvents: function () {
      var that = this;
    },
    initProjectTeaserSliders: function () {
      var that = this;
      $('.js-project-teaser-slider').each(function (index) {
        var cti = $(this).attr('data-ndx');
        appCourseTeaserSlider[index] = new Swiper(
          '.js-project-teaser-slider[data-ndx="' + cti + '"',
          {
            slidesPerView: 4,
            spaceBetween: 28,
            loop: true,
            keyboard: {
              enabled: true,
            },
            navigation: {
              nextEl: '.js-project-teaser-next[data-ndx="' + cti + '"',
              prevEl: '.js-project-teaser-prev[data-ndx="' + cti + '"',
            },
            a11y: {
              enabled: false,
            },
            on: {
              init: function () {
                // Set aria-labels dynamically from markup
                const nextButton = document.querySelector(
                  `.js-project-teaser-next[data-ndx="${cti}"]`,
                );
                const prevButton = document.querySelector(
                  `.js-project-teaser-prev[data-ndx="${cti}"]`,
                );

                if (nextButton) {
                  nextButton.setAttribute(
                    'aria-label',
                    nextButton.getAttribute('data-aria-label'),
                  );
                }
                if (prevButton) {
                  prevButton.setAttribute(
                    'aria-label',
                    prevButton.getAttribute('data-aria-label'),
                  );
                }
              },
            },
          },
        );
      });
    },
  },
  appProjectTeaserSlider = [];
